import React, { useState } from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Flex, Popover, Select, Transfer } from 'antd'
import type { TransferDirection } from 'antd/es/transfer'

const popoverContent = (
  <Flex vertical>
    <div><span className='font-bold'>Cập nhật:</span> Các trường dữ liệu còn trống sẽ được điền thông tin từ tệp nhập liệu.</div>
    <div><span className='font-bold'>Ghi đè:</span> Tất cả trường dữ liệu trên hệ thống sẽ được ghi đè từ tệp nhập liệu.</div>
    <div><span className='font-bold'>Bỏ qua:</span> Hệ thống bỏ qua và không lưu các bản ghi trùng lặp</div>
  </Flex>
)

interface RecordType {
  key: string;
  title: string;
}

const mockData: RecordType[] = [
  { key: '1', title: 'Nghề nghiệp', },
  { key: '2', title: 'Địa chỉ', },
  { key: '3', title: 'Quận huyện', },
  { key: '4', title: 'Thành phố', },
  { key: '5', title: 'Họ tên', },
  { key: '6', title: 'Số điện thoại', },
  { key: '7', title: 'Giới tính', },
  { key: '8', title: 'Ngày sinh', },
]

// const initialTargetKeys = mockData.filter(item => Number(item.key) > 10).map(item => item.key);

const ImportDataStep2: React.FC = () => {
  const [targetKeys, setTargetKeys] = useState<any>([])
  const [selectedKeys, setSelectedKeys] = useState<any>([])

  const onChange = (nextTargetKeys: any, direction: TransferDirection, moveKeys: any) => {
    console.log('targetKeys:', nextTargetKeys)
    console.log('direction:', direction)
    console.log('moveKeys:', moveKeys)
    setTargetKeys(nextTargetKeys)
  }

  // const onChange = (nextTargetKeys: any) => {
  //   setTargetKeys(nextTargetKeys);
  // };

  const onSelectChange = (sourceSelectedKeys: any, targetSelectedKeys: any) => {
    console.log('sourceSelectedKeys:', sourceSelectedKeys)
    console.log('targetSelectedKeys:', targetSelectedKeys)
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys])
  }

  return (
    <div className="import-data-step-2">
      <Flex vertical className='gap-16px'>
        <Flex align='center' className='filter-top'>
          <Select
            placeholder="Cập nhật dữ liệu"
            options={[
              { value: 'bo-qua', label: 'Bỏ qua' },
              { value: 'ghi-de', label: 'Ghi đè' },
              { value: 'cap-nhat', label: 'Cập nhật' },
            ]}
            className="rs-select"

          />
          <Popover
            placement="topLeft"
            title=''
            content={popoverContent}
            rootClassName='rs-popover'
          >
            <div className="icon">
              <InfoCircleOutlined className='neutral-gray-400' />
            </div>
          </Popover>
        </Flex>

        <Transfer
          dataSource={mockData}
          titles={['Cột dữ liệu trên CRM', 'Cột dữ liệu tiêu chí chặn trùng']}
          targetKeys={targetKeys}
          selectedKeys={selectedKeys}
          showSelectAll={false}
          className='rs-transfer'
          onChange={onChange}
          onSelectChange={onSelectChange}
          render={(item: any) => item.title}
        />

        <div className="note">
          LƯU Ý:
          <br />
          - Hệ thống sẽ dựa vào tất cả các tiêu chí chặn trùng của cột dữ liệu bên phải.
          <br />
          - Dựa vào tiêu chí chặn trùng, nếu dữ liệu trên tệp nhập liệu chưa tồn tại trên hệ thống thì được thêm mới vào hệ thống CRM.
        </div>
      </Flex>
    </div>
  )
}

export default ImportDataStep2
